;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["stepupURL", "token", "md", "origin"],
  data: function data() {
    return {
      showHelp: true };
  },
  mounted: function mounted() {
    this.submitForm();
    window.addEventListener("message", this.handleMessage, false);
  },

  methods: {
    submitForm: function submitForm() {
      this.$refs.stepupForm.submit();
    },

    handleMessage: function handleMessage(event) {
      if (event.origin === this.origin) {
        this.$emit("stepupChecked", event.data);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("message", this.handleMessage, false);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"overflow-x-auto"},[_c('iframe',{staticStyle:{"width":"100%"},attrs:{"name":"step-up-iframe","height":"400"}}),_vm._v(" "),_c('form',{ref:"stepupForm",attrs:{"target":"step-up-iframe","method":"POST","action":_vm.stepupURL}},[_c('input',{attrs:{"type":"hidden","name":"JWT"},domProps:{"value":_vm.token}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"MD"},domProps:{"value":_vm.md}})])]),_vm._v(" "),(_vm.showHelp)?_c('div',{staticClass:"flex items-center gap-2.5 px-4 py-3 bg-[#ea9d2c] text-white text-sm font-['Inter'] w-full"},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.99935 1.6665C5.40768 1.6665 1.66602 5.40817 1.66602 9.99984C1.66602 14.5915 5.40768 18.3332 9.99935 18.3332C14.591 18.3332 18.3327 14.5915 18.3327 9.99984C18.3327 5.40817 14.591 1.6665 9.99935 1.6665ZM9.37435 6.6665C9.37435 6.32484 9.65768 6.0415 9.99935 6.0415C10.341 6.0415 10.6243 6.32484 10.6243 6.6665V10.8332C10.6243 11.1748 10.341 11.4582 9.99935 11.4582C9.65768 11.4582 9.37435 11.1748 9.37435 10.8332V6.6665ZM10.766 13.6498C10.7243 13.7582 10.666 13.8415 10.591 13.9248C10.5077 13.9998 10.416 14.0582 10.316 14.0998C10.216 14.1415 10.1077 14.1665 9.99935 14.1665C9.89102 14.1665 9.78268 14.1415 9.68268 14.0998C9.58268 14.0582 9.49102 13.9998 9.40768 13.9248C9.33268 13.8415 9.27435 13.7582 9.23268 13.6498C9.19102 13.5498 9.16602 13.4415 9.16602 13.3332C9.16602 13.2248 9.19102 13.1165 9.23268 13.0165C9.27435 12.9165 9.33268 12.8248 9.40768 12.7415C9.49102 12.6665 9.58268 12.6082 9.68268 12.5665C9.88268 12.4832 10.116 12.4832 10.316 12.5665C10.416 12.6082 10.5077 12.6665 10.591 12.7415C10.666 12.8248 10.7243 12.9165 10.766 13.0165C10.8077 13.1165 10.8327 13.2248 10.8327 13.3332C10.8327 13.4415 10.8077 13.5498 10.766 13.6498Z","fill":"white"}})]),_vm._v(" "),_c('p',{staticClass:"flex-1 leading-tight"},[_vm._v("\n      Having trouble completing authentication from the bank?\n      "),_c('button',{staticClass:"font-semibold underline hover:text-white/80",on:{"click":function($event){return _vm.$emit('tryAnotherWay')}}},[_vm._v("\n        Try another way\n      ")])])]):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d9e8cc8", __vue__options__)
  } else {
    hotAPI.reload("data-v-3d9e8cc8", __vue__options__)
  }
})()}